import { bindable } from 'aurelia-framework';

class ProductFeedsSettingsContainer {
  /**
   * The basic information of the customer account.
   * @type {?AccountInformation}
   */
  @bindable selectedAccount = null;
  /**
   * Callback for when the editor settings has changed.
   * @type {Function}
   */
  @bindable onChanged = () => {};
  /**
   * Whether or not the container is loading information.
   * @type {Boolean}
   */
  loading = false;
  accountSettings = null;
  /**
   * @param {AppErrorPublisher}    appErrorPublisher    To publish errors to the UI.
   * @param {errorParser}          errorParser          Used for error parsing.
   * @param {ProductFeedsSettings} productFeedsSettings To get FeedsSettings.
   * @param {ViewMessages}         viewMessages         To create messages.
   */
  constructor(appErrorPublisher, errorParser, productFeedsSettings, viewMessages) {
    'inject';

    this._appErrorPublisher = appErrorPublisher;
    /**
     * The parser the container will use to format possible errors.
     * @type {ParserrorWrapper}
     * @access protected
     * @ignore
     */
    this._productFeedsSettingsErrorParser = errorParser.wrap();
    this._productFeedsSettings = productFeedsSettings;
    this._viewMessages = viewMessages;
  }
  invalidCode(message) {
    this._viewMessages.notification(`Invalid JSON code: ${message}`, {
      type: 'error',
    });
  }
  saveSettings(settings) {
    this.loading = true;
    this._productFeedsSettings.saveAccountSettings(
      this.selectedAccount.id,
      settings,
    )
    .then(() => {
      this.accountSettings = settings;
    })
    .catch((error) => {
      const parsedError = this._productFeedsSettingsErrorParser(
        error,
        'There was an error saving the settings',
      );

      this._appErrorPublisher.notify(error, parsedError.message);
    })
    .then(() => {
      this.loading = false;
    });
  }
  /**
   * Whenever the selected account changes, if the container is not already loading data, it
   * calls the method that loads the settings.
   */
  selectedAccountChanged() {
    if (!this.loading) {
      this._loadSettings();
    }
  }
  _loadSettings() {
    this.loading = true;
    this._productFeedsSettings.getAccountSettings(this.selectedAccount.id)
    .then((settings) => {
      this.accountSettings = settings;
    })
    .catch((error) => {
      const parsedError = this._productFeedsSettingsErrorParser(
        error,
        'There was an error loading the settings',
      );

      this._appErrorPublisher.notify(error, parsedError.message);
    })
    .then(() => {
      this.loading = false;
    });
  }
}

export { ProductFeedsSettingsContainer };
